export default __webpack_public_path__ + "static/media/774.b4a742be.png";